exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:768px){.signature-modal .modal-dialog{overflow:auto;width:580px;height:auto}.popup-signature{max-width:580px}.popup-signature .container .sign{max-width:480px}.popup-signature .clear-signature{margin-left:50px}.popup-signature .done-div{text-align:center}.popup-signature .done-button{margin:15px auto}.sign-switch a{font-size:12px;color:#3ec19d;bottom:-18px;font-weight:600;font-style:normal;right:0}}.drawSgn p.typeto{font-size:12px!important;color:#3ec19d!important;position:absolute!important;font-weight:600!important;font-style:normal!important;right:0!important}.drawSgn p.typeto:hover{cursor:pointer}@media screen and (max-width:768px){.signature-modal .modal-dialog{overflow:auto;width:320px;height:auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/freeforms/newSignatureModal/signatureBase.css
// module id = 349
// module chunks = 0